import { GirafeHTMLElement } from '@geogirafe/lib-geoportal/base';
import { Service } from '../service/service';
import { LiegenschaftState } from '../../../bs/types';

class LiegenschaftskenndatenComponent extends GirafeHTMLElement {
  templateUrl = './template.html';
  styleUrls = ['../../../../node_modules/@geogirafe/lib-geoportal/styles/common.css', '../item-style.css'];

  private readonly templateName = 'Liegenschaftskenndaten_Riehen';
  service!: Service;
  protected showModal = false;

  protected get reportState(): LiegenschaftState {
    return this.state.extendedState[this.templateName] as LiegenschaftState;
  }

  protected get reportConfig() {
    return this.context.configManager.Config.extendedConfig!.reportService;
  }

  constructor() {
    super('liegenschafts-kenndaten-component');
  }

  private initialize() {
    if (!this.state.extendedState[this.templateName]) {
      this.state.extendedState[this.templateName] = {
        currentState: 'inactive'
      };
    }

    this.service = new Service(this.context);
  }

  protected override connectedCallback() {
    super.connectedCallback();
    this.initialize();
    super.render();
    this.registerEvents();
  }

  private registerEvents() {
    this.subscribe(`extendedState\.${this.templateName}\.currentState`, () => this.reportStateChanged());
    this.context.mapManager.getMap().on('singleclick', () => this.onMapClick());
  }

  protected onReportClick() {
    if (this.reportState.currentState === 'inactive') {
      this.reportState.currentState = 'active';
    } else if (this.reportState.currentState === 'active') {
      this.reportState.currentState = 'inactive';
    } else if (this.reportState.currentState === 'download') {
      window.open(this.reportState.downloadUrl);
      this.reportState.currentState = 'inactive';
    } else if (this.reportState.currentState === 'error') {
      this.reportState.currentState = 'inactive';
    }
  }

  private reportStateChanged() {
    if (this.reportState.currentState === 'active') {
      this.registerInteractionListener('map.mouseclick', true);
      this.updateCursorStyle();
    } else {
      this.unregisterInteractionListeners('map.mouseclick');
      this.updateCursorStyle();
    }
    this.refreshRender();
  }

  private updateCursorStyle() {
    const targetElement = this.context.mapManager.getMap().getTargetElement();
    targetElement.style.cursor = this.reportState.currentState === 'active' ? 'crosshair' : 'default';
  }

  async onMapClick() {
    if (!this.canExecute('map.mouseclick')) {
      return;
    }

    try {
      const coord = this.state.mouseCoordinates;
      const east = coord[0].toFixed(3);
      const north = coord[1].toFixed(3);

      // WFS query
      this.reportState.currentState = 'processing';
      this.refreshRender();

      const features = await this.service.getFeaturesForLiegenschaft(Number(east), Number(north));
      if (features.length === 0) {
        this.reportState.currentState = 'inactive';
        this.reportState.errorMessage = 'Für den gewählten Standort sind keine Daten verfügbar.';
      } else if (features.length > 1) {
        // Multiple liegenschaften were found
        // TODO REG : Implement showModal. For the moment we just take the first one and use it for the report
        // I think we should give a common way in the geogirafe core to select between 2 entries.
        // I would wait this standard mechanism before integrating this.
        this.showModal = true;
        this.showModal = true;
        const resultUrl = await this.service.createReport(this.templateName, features[0].egrid);
        this.reportState.downloadUrl = resultUrl;
        this.reportState.currentState = 'download';
      } else {
        // Report
        const resultUrl = await this.service.createReport(this.templateName, features[0].egrid);
        this.reportState.downloadUrl = resultUrl;
        this.reportState.currentState = 'download';
      }
    } catch (err) {
      this.reportState.errorMessage = String(err);
      this.reportState.currentState = 'error';
    } finally {
      this.refreshRender();
    }
  }
}

export default LiegenschaftskenndatenComponent;
